/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedIconBubbleFacebook_item = {
    readonly title: string | null;
    readonly " $refType": "PdpSharedIconBubbleFacebook_item";
};
export type PdpSharedIconBubbleFacebook_item$data = PdpSharedIconBubbleFacebook_item;
export type PdpSharedIconBubbleFacebook_item$key = {
    readonly " $data"?: PdpSharedIconBubbleFacebook_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleFacebook_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubbleFacebook_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '1ee214ae8acee7f3ada289e7d82a9d20';
export default node;
